import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { AuthService } from 'src/services/auth.service';

import { FEATURES } from '../../constants';

@Component({
  selector: 'app-knowledge-base-layout',
  templateUrl: './knowledge-base-layout.component.html',
  styleUrls: ['./knowledge-base-layout.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, IonicModule],
})
export class KnowledgeBaseLayoutComponent implements OnInit {
  showRunQueryModal = false;
  featureEnabled = true;

  constructor(
    public router: Router,
    public authService: AuthService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.featureEnabled = !this.authService.restrictedFeatures.includes(FEATURES.KNOWLEDGE_BASE_SYNC);
  }

  createArticle() {
    this.router.navigate(['./articles/new'], { relativeTo: this.route });
  }

  openRunQueryModal() {
    this.showRunQueryModal = true;
  }

  onDismissRunQueryModal() {
    this.showRunQueryModal = false;
  }
}
